module.exports = __webpack_public_path__ + "media/images/site/hits-c177f85cced9b2bdd2090b134ca02dc1.svg";